const isApiContext = window.location.href.includes('/api/');
const apiPrefix = isApiContext ? '/api' : '';
const accountsPrefix = window.__CONFIG__.APP_URI_PREFIX;
export const SIDE_BAR_TABS = {
  SEARCH_HISTORY: { name: 'search-history', path: '/manage/history/', label: 'Search history', app: 'insights' },
  SUBSCRIPTION: {
    name: 'subscription',
    path: '/manage/subscriptions/v2/',
    label: 'Subscription',
    app: 'insights',
  },
  ORGANIZATION_DETAILS: {
    name: 'organization-details',
    path: `${apiPrefix}/${accountsPrefix}organization/`,
    label: 'Organization details',
    app: 'accounts',
  },
  PROFILE: { name: 'profile', path: `${apiPrefix}/${accountsPrefix}profile/`, label: 'Profile', app: 'accounts' },
  API_DEMO: { name: 'api-demo', path: '/api/demo/', label: 'API demo', app: 'demo-api' },
  API_USAGE: { name: 'api-usage', path: '/api/manage/usage/', label: 'Usage', app: 'api' },
  API_ALERTS: { name: 'api-alerts', path: '/api/manage/alerts/', label: 'Alerts', app: 'api' },
  API_QUERIES: { name: 'api-queries', path: '/api/manage/queries/', label: 'Queries log', app: 'api' },
  USERS_AND_TEAMS: {
    name: 'users-and-teams',
    path: `${apiPrefix}/${accountsPrefix}manage-users/`,
    label: 'Users and teams',
    app: 'accounts',
  },
  USAGE_ANALYTICS: {
    name: 'usage-analytics',
    path: `${apiPrefix}/${accountsPrefix}usage/per-user/`,
    label: 'Usage analytics',
    app: 'accounts',
  },
  API_KEYS: { name: 'api-keys', path: '/api/manage/keys/', label: 'API keys' },
  BILLING: {
    name: 'billing',
    path: `${apiPrefix}/${accountsPrefix}billing/`,
    label: 'Billing information',
    app: 'accounts',
  },
};
const analyticsEnabled = window.__CONFIG__.USAGE_ANALYTICS_ENABLED;

export const GROUPS = [
  isApiContext
    ? {
        title: 'API reports',
        items: [SIDE_BAR_TABS.API_USAGE, SIDE_BAR_TABS.API_ALERTS, SIDE_BAR_TABS.API_QUERIES],
      }
    : {
        title: 'Insights reports',
        items: analyticsEnabled
          ? [SIDE_BAR_TABS.SEARCH_HISTORY, SIDE_BAR_TABS.USAGE_ANALYTICS]
          : [SIDE_BAR_TABS.SEARCH_HISTORY],
      },
  {
    title: 'My organization',
    items: isApiContext
      ? [
          SIDE_BAR_TABS.ORGANIZATION_DETAILS,
          SIDE_BAR_TABS.USERS_AND_TEAMS,
          SIDE_BAR_TABS.API_KEYS,
          SIDE_BAR_TABS.API_DEMO,
          SIDE_BAR_TABS.BILLING,
        ]
      : [
          SIDE_BAR_TABS.ORGANIZATION_DETAILS,
          SIDE_BAR_TABS.USERS_AND_TEAMS,
          SIDE_BAR_TABS.SUBSCRIPTION,
          SIDE_BAR_TABS.BILLING,
        ],
  },
];
